var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15H28V7H13V5H28C28.5302 5.00061 29.0386 5.21152 29.4135 5.58646C29.7885 5.9614 29.9994 6.46975 30 7V15Z",
    fill: "#FFBA07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 20H23V12H8V10H23C23.5302 10.0006 24.0386 10.2115 24.4135 10.5865C24.7885 10.9614 24.9994 11.4698 25 12V20Z",
    fill: "#076AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 16,
    height: 10,
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27H4C3.46975 26.9994 2.9614 26.7885 2.58646 26.4135C2.21152 26.0386 2.00061 25.5302 2 25V17C2.00061 16.4698 2.21152 15.9614 2.58646 15.5865C2.9614 15.2115 3.46975 15.0006 4 15H18C18.5302 15.0006 19.0386 15.2115 19.4135 15.5865C19.7885 15.9614 19.9994 16.4698 20 17V25C19.9994 25.5302 19.7885 26.0386 19.4135 26.4135C19.0386 26.7885 18.5302 26.9994 18 27ZM4 17V25H18.0012L18 17H4Z",
    fill: "#FFC907"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.5e5ca4cdc6a77e08464e103e67053e4a.svg";
export { ForwardRef as ReactComponent };